import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useSearchParams } from 'react-router-dom';
import { Button, InlineNotification } from '@carbon/react';
import { useAuthActions } from 'src/hooks/useAuthActions';
import { useAuthSession } from 'src/hooks/useAuthSession';

const VerifyEmail = () => {
  const { t } = useTranslation('authentication');
  const [searchParams] = useSearchParams();
  const { user } = useAuthSession();
  const { resendVerification, isPending } = useAuthActions();
  const [sent, setSent] = useState(false);
  const email = searchParams.get('email') ?? user?.email ?? '';

  return (
    <div className="cds--auth__form">
      <h1>{t('verifyEmail.title')}</h1>
      <p>{t('verifyEmail.body', { email })}</p>
      {sent && <InlineNotification kind="success" title={t('verifyEmail.resent')} lowContrast hideCloseButton />}
      <Button
        disabled={isPending || !email}
        onClick={async () => {
          await resendVerification(email);
          setSent(true);
        }}
      >
        {t('verifyEmail.resend')}
      </Button>
    </div>
  );
};

export default VerifyEmail;
